export default __webpack_public_path__ + "media/d25e504d0916c14a785dcccb9ad41f8759492a9b3cbe8ba507ce3f283e9792f1.svg";